import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useSEO = ({ title, description, keywords }) => {
  const location = useLocation();
  const baseUrl = 'https://newyorkcityseo.agency';

  useEffect(() => {
    // Update Title - Set directly to ensure precise character count from components
    document.title = title;

    // Update Meta Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    // Update Canonical Tag
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    const path = location.pathname === '/' ? '' : location.pathname;
    canonical.href = `${baseUrl}/#${path}`;

  }, [title, description, keywords, location]);
};